import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const quorumTealPalette = palette('#00A6A6');

export const customThemePreset = definePreset(Aura, {
    semantic: {
        primary: quorumTealPalette
    },
    components: {
        menu: {
            item: {
                padding: `0.125rem 0.75rem`,
            },
            separator: {
                marginTop: '0.25rem'
            }
        }
    },
    css: ({ dt }: {dt: any}) => `
        .left-nav .p-menu-item-link-active {
            background-color: ${dt('primary.color')};
            color: ${dt('primary.contrast.color')}
        }
        .left-nav .p-menu-separator {
            margin-top: 0.25rem;
        }
    `
});
